"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionAdminPage = exports.getArrayValue = exports.getValue = exports.delimiter = void 0;
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const classifiers_1 = require("../../classifiers");
exports.delimiter = ';';
const getValue = (value) => (value ? value.trim() : '');
exports.getValue = getValue;
const getArrayValue = (value) => value && value.trim()
    ? value
        .split(exports.delimiter)
        .map(exports.getValue)
        .filter((value) => !!value)
    : [];
exports.getArrayValue = getArrayValue;
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            { label: t('defaultClassifiers.state'), value: props.response.data.state },
            { label: t('defaultClassifiers.counties'), value: props.response.data.counties.join(', ') },
            { label: t('common.status'), value: t(`classifiers.statusEnum.${props.response.data.status}`) },
            { label: t('classifiers.displayOrder'), value: (_a = props.response.data.displayOrder) !== null && _a !== void 0 ? _a : react_1.default.createElement("em", null, "(not set)") },
        ] }));
};
const csvFileHeader = ['ID', 'Name', 'State Code', 'Counties', 'Status', 'Display Order'];
function mapCsvRowToData(row) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
        const state = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim();
        const counties = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim();
        const status = ((_e = row.data[4]) !== null && _e !== void 0 ? _e : '').trim().toLowerCase();
        const displayOrder = ((_f = row.data[5]) !== null && _f !== void 0 ? _f : '').trim();
        const validCounties = [];
        if (name.length === 0) {
            row.errors.push('Name is required');
        }
        if (status.length === 0) {
            row.errors.push('Status is required');
        }
        if (state.length === 0) {
            row.errors.push('State Code is required');
        }
        if (counties.length === 0) {
            row.errors.push('Counties are required');
        }
        if (counties) {
            const countiesValues = (0, exports.getArrayValue)(counties);
            countiesValues.forEach((county) => {
                getJurisdictionByName(state, row.errors, 'County not found: ' + county, [
                    { column: 'name', op: '=', value: county },
                    { column: 'type', op: '=', value: 'county' },
                    { column: 'status', op: '=', value: 'active' },
                ]).then((columns) => columns && validCounties.push(columns.name));
            });
            yield checkIfCountiesAreUsed(name, validCounties, row.errors);
        }
        switch (status) {
            case 'active':
            case 'deprecated':
            case 'retired':
                break;
            default:
                row.errors.push('Invalid status, expected one of: active, deprecated, retired');
        }
        let displayOrderNumber;
        if (displayOrder) {
            displayOrderNumber = parseFloat(displayOrder);
            if (!isFinite(displayOrderNumber)) {
                row.errors.push('Invalid display number, expected a number');
                displayOrderNumber = undefined;
            }
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name: name,
                    state: state !== null && state !== void 0 ? state : '',
                    counties: validCounties !== null && validCounties !== void 0 ? validCounties : '',
                    status: status,
                    displayOrder: displayOrderNumber,
                },
            };
        }
        return Promise.resolve(row);
    });
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return [
            response.id,
            response.data.name,
            response.data.state,
            response.data.counties.join(';').toString(),
            response.data.status,
            response.data.displayOrder != null ? response.data.displayOrder.toString() : '',
        ];
    });
}
function getJurisdictionByName(value, errors, errorMessage, filter) {
    return __awaiter(this, void 0, void 0, function* () {
        if (value) {
            const result = yield new StorageClient_1.StorageClient('jurisdiction').list({
                filter: [{ column: 'parentPostalCode', op: '=', value }, ...(filter ? filter : [])],
                limit: 1,
            });
            if (result.rows.length > 0) {
                return result.rows[0].columns;
            }
            else {
                errors.push(errorMessage);
            }
        }
        return undefined;
    });
}
function checkIfCountiesAreUsed(regionName, values, errors) {
    return __awaiter(this, void 0, void 0, function* () {
        if (values.length > 0) {
            const result = yield new StorageClient_1.StorageClient('region').list({
                filter: [
                    { column: 'counties', op: 'overlap', value: values },
                    { column: 'name', op: '=', value: regionName },
                ],
            });
            if (result.rows.length > 0) {
                const duplicates = [];
                result.rows.forEach((row) => {
                    row.columns.counties.forEach((resultCounty) => {
                        if (values.includes(resultCounty)) {
                            duplicates.push(resultCounty);
                        }
                    });
                });
                errors.push('These counties/parishes: ' + duplicates.join(', ') + 'are used in: ' + regionName);
            }
        }
    });
}
const RegionAdminPage = ({ includeTerritories }) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const formConfig = {
        type: 'form',
        children: [
            {
                type: 'form.text',
                key: 'name',
                label: t('common.name'),
                validate: {
                    required: true,
                },
            },
            {
                type: 'form.select',
                key: 'state',
                label: includeTerritories ? t('defaultClassifiers.stateAndTerritory') : t('defaultClassifiers.state'),
                validate: {
                    required: true,
                },
                valueProvider: { type: includeTerritories ? 'classifier.stateAndTerritory' : 'classifier.state' },
            },
            {
                type: 'form.multiSelect',
                key: 'counties',
                label: t('defaultClassifiers.counties'),
                validate: {
                    required: true,
                },
                valueProvider: { type: 'classifier.county', paramsFrom: '^state' },
            },
            {
                type: 'form.select',
                key: 'status',
                label: t('common.status'),
                validate: {
                    required: true,
                },
                values: [
                    {
                        value: 'active',
                        label: t('classifiers.statusEnum.active'),
                    },
                    {
                        value: 'deprecated',
                        label: t('classifiers.statusEnum.deprecated'),
                    },
                    {
                        value: 'retired',
                        label: t('classifiers.statusEnum.retired'),
                    },
                ],
            },
            {
                type: 'form.number',
                key: 'displayOrder',
                label: t('classifiers.displayOrder'),
            },
        ],
    };
    return (react_1.default.createElement(classifiers_1.ClassifierAdminPage, { entity: shared_1.regionEntityName, title: t('defaultClassifiers.region'), fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
exports.RegionAdminPage = RegionAdminPage;
